document.addEventListener("alpine:init", () => {
  let dataSourceAPI = "/course/api/flexible-locations/academic-items";

  let t;

  if ((t = location.hostname.match(/(qas|dev)\./))) {
    dataSourceAPI = dataSourceAPI.replace(/(\/\/www)(\.)/, "$1" + t[1] + "$2");
  }

  if (STUDYFLEX_DATA.config && STUDYFLEX_DATA.config.dataSourceAPI) {
    dataSourceAPI = STUDYFLEX_DATA.config.dataSourceAPI;
  }

  const locationMap = {
    BU: "Melbourne",
    BE: "Bendigo",
    CI: "City",
    MI: "Mildura",
    OT: "Other",
    SH: "Shepparton",
    SY: "Sydney",
    ON: "Online",
    WO: "Albury-Wodonga",
  };

  const studyLevelMap = {
    UG: "Undergraduate",
    PG: "Postgraduate",
    PGR: "Research",
  };

  const locationMapReverse = Object.fromEntries(
    Object.entries(locationMap).map((a) => a.reverse())
  );

  let _timeoutIDApplyFilters;

  const appScope = STUDYFLEX_DATA.scope;
  const appConfig = STUDYFLEX_DATA.config;
  const storePrefix = appScope ? appScope + "_" : "";
  const storeName = `${storePrefix}studyFlex`;

  function _getFirstLevelFilterConfig(key) {
    return appConfig.firstLevelFilters && appConfig.firstLevelFilters[key]
      ? appConfig.firstLevelFilters[key]
      : {};
  }

  function _getSecondLevelFilterConfig(key) {
    return appConfig.secondLevelFilters && appConfig.secondLevelFilters[key]
      ? appConfig.secondLevelFilters[key]
      : {};
  }

  function _generateFirstLevelFilterConfigObject() {
    const _today = new Date();

    const _defaultConfig = [
      {
        key: "studyLevels",
        inputType: "radio",
        show: true,
        label: "Study level:",
        options: [
          // { value: "", label: "All" },
          { value: "UG", label: "Undergraduate" },
          { value: "PG", label: "Postgraduate" },
        ],
      },
      {
        key: "academicYears",
        inputType: "radio",
        show: true,
        label: "Begin study in:",
        options: [
          {
            value: _today.getFullYear().toString(),
            label: _today.getFullYear().toString(),
          },
        ],
        sortOption: "desc",
      },
      {
        key: "studyFlexOptions",
        inputType: "radio",
        label: "StudyFlex Options:",
        show: true,
        options: [
          { value: "course", label: "StudyFlex course" },
          { value: "major", label: "StudyFlex major" },
          { value: "minor", label: "StudyFlex minor" },
          { value: "specialisation", label: "StudyFlex specialisation" },
        ],
      },
    ];

    function _replaceWithDefaultOptions(customOptions, defaultOptions) {
      if (Array.isArray(customOptions)) {
        const _mapDefault = {};
        defaultOptions.forEach((v) => (_mapDefault[v.value] = v));

        customOptions = customOptions.map((v) =>
          typeof v === "string" ? _mapDefault[v] : v
        );
      }

      return customOptions;
    }

    const obj = {};

    _defaultConfig.forEach((_default) => {
      const _customConfig = _getFirstLevelFilterConfig(_default.key);

      const inputType = _customConfig.inputType || _default.inputType;
      const show =
        typeof _customConfig.show === "undefined"
          ? _default.show
          : _customConfig.show;
      const label = _customConfig.label || _default.label;
      let options =
        _replaceWithDefaultOptions(_customConfig.options, _default.options) ||
        (_customConfig.show ? [] : _default.options);
      const sortOption =
        typeof _customConfig.sortOption === "undefined"
          ? _default.sortOption
          : _customConfig.sortOption;

      if (options && options.length && sortOption) {
        options = _sortOptions(options, sortOption);
      }

      obj[_default.key] = {
        inputType,
        show,
        label,
        options,
        sortOption,
      };
    });

    return obj;
  }

  function _sortOptions(options, order) {
    const newOptions = [...options];
    if (order === "asc") {
      newOptions.sort((a, b) =>
        a.label > b.label ? 1 : b.label > a.label ? -1 : 0
      );
    } else if (order === "desc") {
      newOptions.sort((a, b) =>
        a.label > b.label ? -1 : b.label > a.label ? 1 : 0
      );
    } else {
      console.error(`unsupported sortOption order: ${order}`);
    }
    return newOptions;
  }

  function _generateSecondLevelFilterConfigObject() {
    const _defaultConfig = [
      {
        key: "disciplines",
        label: "Disciplines",
        show: true,
        showSelectAllToggle: true,
        options: [
          {
            value: "Arts, social sciences and communications",
            label: "Arts, social sciences and communications",
          },
          {
            value: "Business and commerce",
            label: "Business and commerce",
          },
          {
            value: "Criminology",
            label: "Criminology",
          },
          {
            value: "Education and teaching",
            label: "Education and teaching",
          },
          {
            value: "Engineering",
            label: "Engineering",
          },
          {
            value: "Health",
            label: "Health",
          },
          {
            value: "Information technology",
            label: "Information technology",
          },
          {
            value: "Law",
            label: "Law",
          },
          {
            value: "Science",
            label: "Science",
          },
        ],
      },
      {
        key: "locations",
        label: "Locations",
        show: true,
        showSelectAllToggle: true,
        options: [
          {
            value: "BU",
            label: "Melbourne (Bundoora)",
          },
          {
            value: "WO",
            label: "Albury-Wodonga",
          },
          {
            value: "BE",
            label: "Bendigo",
          },
          {
            value: "MI",
            label: "Mildura",
          },
          {
            value: "ON",
            label: "Online",
          },
          {
            value: "OT",
            label: "Other",
          },
          {
            value: "SH",
            label: "Shepparton",
          },
          {
            value: "SY",
            label: "Sydney",
          },
        ],
      },
    ];

    const obj = {};

    _defaultConfig.forEach((_default) => {
      const _customConfig = _getSecondLevelFilterConfig(_default.key);

      const label = _customConfig.label || _default.label;
      const show =
        typeof _customConfig.show === "undefined"
          ? _default.show
          : _customConfig.show;
      const showSelectAllToggle =
        typeof _customConfig.showSelectAllToggle === "undefined"
          ? _default.showSelectAllToggle
          : _customConfig.showSelectAllToggle;
      const showSubFilters =
        typeof _customConfig.showSubFilters === "undefined"
          ? _default.showSubFilters
          : _customConfig.showSubFilters;
      const options =
        _customConfig.options || (_customConfig.show ? [] : _default.options);

      if (showSelectAllToggle) {
        options.unshift({ value: "", label: "All", subFilterOptions: [] });
      }

      obj[_default.key] = {
        label,
        show,
        showSelectAllToggle,
        showSubFilters,
        options,
      };
    });

    return obj;
  }

  Alpine.data("studyFlexSearchControls", () => ({
    // configurations

    /*

    First level filter configuration structure:

    ** default config object
    {
      key: "{key}",
      inputType: "radio" / "checkbox",
      show: true / false,
      label: "{label}",
      options: [
        { value: "valueA", label: "Label A", explainerText (optional field): "Explainer A"  },
        { value: "valueB", label: "Label B" },
        { value: "valueC", label: "Label C" },
      ],

    },

    ** custom config object & transformed config object
    {
      {key}: {
        inputType: "radio" / "checkbox",
        show: {Boolean},
        label: "{label}",
        options: [
          { value: "valueA", label: "Label A", explainerText: "Explainer A" },
          "valueB", // will look up and replace with default option
          { value: "valueC", label: "Label C" },
          ...
        ]
      },
    },

    Second level filter configuration structure:

    ** default config object
    [
      {
        key: "{key}",
        label: "Filter A".
        show: true / false,
        showSelectAllToggle: true / false,
        showSubFilters: true / false,
        options: [
          {
            value: "valueA",
            label: "Label A",
            subFilterOptions: [
              { value: "valueB", label: "Label B" },
              ...
            ]
          },
          ...
        ],
      },
    ],

    ** custom config object & transformed config object
    {
      {key}: {
        label: "Filter A"
        show: {Boolean},
        showSelectAllToggle: {Boolean},
        showSubFilters: {Boolean},
        filterOptions: [
          {
            value: "valueA",
            label: "Label A",
            subFilterOptions: [
              { value: "valueB", label: "Label B" },
              ...
            ]
          },
          ...
        ]
      },
    },

    */

    firstLevelFiltersConfig: _generateFirstLevelFilterConfigObject(),
    secondLevelFiltersConfig: _generateSecondLevelFilterConfigObject(),

    storeName: storeName,

    showSecondLevelFilters:
      typeof appConfig.showSecondLevelFilters !== "undefined"
        ? appConfig.showSecondLevelFilters === true
        : true,

    clientSideFilter: [
      // 'academicYears',
      // 'studyMode',
    ],

    // states
    showSecondLevelFilterMenu: false,
    secondLevelFilters: {},
    overwriteResult: {},

    _getStore() {
      return this.$store[this.storeName];
    },

    init() {
      for (const [filterKey, filterConfig] of Object.entries(
        this.secondLevelFiltersConfig
      )) {
        if (
          filterConfig.showSelectAllToggle &&
          this._getStore().secondLevelFilters[filterKey].length == 0
          // this._getStore().secondLevelFilters[filterKey].indexOf("") === -1
        ) {
          this._getStore().secondLevelFilters[filterKey].push("");
        }
      }

      this._setInputDefaultValues(["academicYears"]);

      this.getData().then(() => {
        this._setInputDefaultValues();
        this._applyFilters();
      });
    },

    /**
     * @param {*} skipFilters skipFilters is used for delaying update till second round after facet data is ready
     */
    _setInputDefaultValues(skipFilters) {
      skipFilters = skipFilters || [];

      // populate first level filters
      const allFilters = ["studyLevels", "academicYears", "studyFlexOptions"];
      const filtersToUpdate = allFilters.filter(
        (x) => !skipFilters.includes(x)
      );

      filtersToUpdate.forEach((k) => {
        if (
          this.firstLevelFiltersConfig[k].show &&
          this._getStore().firstLevelFilters[k].length === 0
        ) {
          this._getStore().firstLevelFilters[k] = [
            this.firstLevelFiltersConfig[k].options[0].value,
          ];
        }
      });

      this.secondLevelFiltersConfig.disciplines.show =
        this._getStore().firstLevelFilters.studyFlexOptions[0] == "course";

      this._updateFilterOptionsUIState();
    },

    getData() {
      return fetch(dataSourceAPI)
        .then((response) => response.json())
        .then((result) => {
          // setting default year
          const k = "academicYears";

          const filterConfig = this.firstLevelFiltersConfig[k];

          const availableYears = Object.keys(result.data);

          let _newOptions = availableYears.map((v) => {
            return {
              value: v,
              label: v,
            };
          });

          if (filterConfig.sortOption) {
            _newOptions = _sortOptions(_newOptions, filterConfig.sortOption);
          }

          filterConfig.options = _newOptions;

          if (
            filterConfig.show &&
            // initial state - store value (array) is empty
            (this._getStore().firstLevelFilters[k].length === 0 ||
              // restored state - store value (array) contains invalid value
              this._getStore().firstLevelFilters[k].filter((v) =>
                availableYears.includes(v)
              ).length === 0)
          ) {
            this._getStore().firstLevelFilters[k] = [_newOptions[0].value];
          }

          // store data into store

          this._getStore().allAcademicItems = result.data;
        });
    },

    toggleFilterMulti(filterName, $el) {
      const [filterGroup, filterKey] = filterName.split(/\.(.+?)$/);
      const value = $el.value;

      const _inputGroupSelector = 'input[name="' + $el.name + '"]';

      const _defaultValue = "";

      if (value === _defaultValue) {
        const list = document.querySelectorAll(_inputGroupSelector);
        Array.prototype.forEach.call(list, function (dom) {
          dom.checked = dom.value === _defaultValue;
        });
      } else {
        const nonDefaultCheckedList = document.querySelectorAll(
          _inputGroupSelector + ':not([value=""]):checked'
        );

        const _defaultNode = document.querySelector(
          _inputGroupSelector + '[value=""]'
        );

        if (_defaultNode) {
          _defaultNode.checked = nonDefaultCheckedList.length === 0;
        } else {
          // re-check all nodes if none are checked
          if (nonDefaultCheckedList.length === 0) {
            Array.prototype.forEach.call(
              document.querySelectorAll(_inputGroupSelector),
              function (dom) {
                dom.checked = dom.value !== _defaultValue;
              }
            );
          }
        }
      }

      // update store
      const checkedList = document.querySelectorAll(
        _inputGroupSelector + ":checked"
      );
      const newVals = [];
      Array.prototype.forEach.call(checkedList, function (dom) {
        newVals.push(dom.value);
      });

      this._getStore()[filterGroup][filterKey] = newVals;

      // avoid unecessary request
      if (!this._getStore().hideResultComponent) {
        this._delayedApplyFilters();
      }
    },

    onClickMultiFilter($event, $el, filterConfig, filterName) {
      // document
      //   .querySelectorAll("[data-custom-message-trigger]:checked")
      //   .forEach((node) => $el !== node && (node.checked = false));

      this._getStore().hideResultComponent = false;
      this.overwriteResult = {};

      const overwriteResult =
        typeof appConfig.overwriteResult === "function"
          ? appConfig.overwriteResult(
              $event,
              $el,
              this.$root,
              filterConfig,
              filterName
            )
          : null;

      if (overwriteResult !== null) {
        // $event.preventDefault()
        this._getStore().hideResultComponent = true;
        this._getStore().allAcademicItems = [];

        this.overwriteResult = { ...overwriteResult };
      }

      // Hard coded UI state
      if (filterName === "firstLevelFilters.studyFlexOptions") {
        // discipline filter inputs are being ignored in data filtering process instead of resetting to unchecked
        this.secondLevelFiltersConfig.disciplines.show = $el.value === "course";
      }

      if (filterName === "firstLevelFilters.studyLevels") {
        // force selecting "StudyFlex course" option when study level is changed
        document.querySelector(
          'input[name="studyFlexOptions"][value="course"]'
        ).checked = true;
        this._getStore().firstLevelFilters.studyFlexOptions[0] = "course";

        this._updateFilterOptionsUIState();
      }

      this.toggleFilterMulti(filterName, $el);
    },

    scrollToFilter: function (destination) {
      //scrollIntoView options object is experimental
      document
        .querySelector(destination)
        .scrollIntoView({ behavior: "smooth" });
    },

    deselectFilter(filterName, item) {
      const [filterGroup, filterKey] = filterName.split(/\.(.+?)$/);

      const namePrefix =
        filterGroup === "secondLevelFilters"
          ? "second-level-filter-"
          : "first-level-filter-";

      $el = document.querySelector(
        `input[name="${namePrefix}${filterKey}"][value="${item}"]`
      );
      $el.checked = false;

      this.toggleFilterMulti(filterName, $el);
    },

    _delayedApplyFilters() {
      clearTimeout(_timeoutIDApplyFilters);

      this._getStore().isLoading = true;
      _timeoutIDApplyFilters = setTimeout(() => this._applyFilters(), 500);
    },

    _applyFilters() {
      const source = JSON.parse(
        JSON.stringify(this._getStore().allAcademicItems)
      );

      const _firstLevelFilters = this._getStore().firstLevelFilters;

      const selectedStudyFlexOption = _firstLevelFilters.studyFlexOptions[0];
      const selectedStudyLevels = _firstLevelFilters.studyLevels.slice(0);
      if (selectedStudyLevels.includes("UG")) {
        selectedStudyLevels.push("HON");
      }

      const raw =
        source[_firstLevelFilters.academicYears[0]][
          `${selectedStudyFlexOption}s`
        ];

      const filteredAcademicItems = raw
        .map(this._mapAndFilterSearchResult.bind(this))
        .filter((x) => !!x);
      this._getStore().filteredAcademicItems = filteredAcademicItems;
      this._getStore().isLoading = false;
    },

    // We only need to filter instance/detail data
    _mapAndFilterSearchResult(row) {
      const _firstLevelFilters = this._getStore().firstLevelFilters;
      const _secondLevelFilters = JSON.parse(
        JSON.stringify(this._getStore().secondLevelFilters)
      ); // potential overhead
      // filtering '' (empty string) that represent "All" filter option
      for (var i in _secondLevelFilters) {
        _secondLevelFilters[i] = _secondLevelFilters[i].filter((v) => !!v);
      }

      const selectedStudyFlexOption = _firstLevelFilters.studyFlexOptions[0];
      const selectedStudyLevels = _firstLevelFilters.studyLevels.slice(0);
      if (selectedStudyLevels.includes("UG")) {
        selectedStudyLevels.push("HON");
      }

      const _setupCourseExtraData = (course) => {
        const _rawLocation = course.location;
        course.location =
          _rawLocation === "Melbourne" ? "Melbourne (Bundoora)" : _rawLocation;
        course.url +=
          "?" +
          "studentType=dom" +
          "&location=" +
          locationMapReverse[_rawLocation];

        course.isFutureYear =
          course.academicYear >
          parseInt(_firstLevelFilters.academicYears[0], 0);

        return course;
      };

      const _arrayIntersect = (arr1, arr2) => {
        return arr1.filter((val) => arr2.includes(val));
      };

      let _result = null;
      switch (selectedStudyFlexOption) {
        case "course":
          if (
            selectedStudyLevels.includes(row.studyLevel) &&
            (!_secondLevelFilters.disciplines.length ||
              !!_arrayIntersect(
                _secondLevelFilters.disciplines,
                row.disciplines
              ).length) &&
            (!_secondLevelFilters.locations.length ||
              _secondLevelFilters.locations.includes(
                locationMapReverse[row.location]
              ))
          ) {
            _result = _setupCourseExtraData(row);
          }
          break;
        case "major":
        case "minor":
        case "specialisation":
          if (
            !_secondLevelFilters.locations.length ||
            !!_arrayIntersect(_secondLevelFilters.locations, row.locationCodes)
              .length
          ) {
            _result = {
              ...row,
              locations: row.locationCodes.map((c) =>
                c === "BU" ? "Melbourne (Bundoora)" : locationMap[c]
              ),
            };

            _result._courses = Object.fromEntries(
              Object.entries(_result._courses).map(([k, v]) => [
                k,
                v
                  .filter((c) => selectedStudyLevels.includes(c.studyLevel))
                  .map(_setupCourseExtraData),
              ])
            );

            // _result._courses = _result._courses
            //   .filter((c) => selectedStudyLevels.includes(c.studyLevel))
            //   .map(_setupCourseExtraData);
          }
          break;
      }

      if (!!_result) {
        // common metadata to be used in UI
        _result._metadata = {
          expanded: false,
          toggleExpand() {
            this.expanded = !this.expanded;
          },
        };
      }

      return _result;
    },

    toggleSecondLevelFilterMenu() {
      const _newShowFilters = this.$el.classList.contains(
        "ds-filter-group__nav__tab"
      )
        ? this.$el.getAttribute("aria-expanded") === "true"
        : !this.showSecondLevelFilterMenu;

      if (_newShowFilters != this.showSecondLevelFilterMenu) {
        this.$refs.btnShowSecondLevelFilterMenu.classList.toggle(
          "ds-btn--ghost__active"
        );
        this.$refs.btnShowSecondLevelFilterMenu.classList.toggle(
          "ds-icon-filter"
        );
        this.$refs.btnShowSecondLevelFilterMenu.classList.toggle("ds-icon-x");

        this.showSecondLevelFilterMenu = _newShowFilters;
      }

      if (!_newShowFilters) {
        this.$refs.secondLevelFilterContainer
          .querySelectorAll('[aria-expanded="true"]')
          .forEach((elem) => {
            elem.setAttribute("aria-expanded", false);
          });
      }
    },

    scrollToSecondLevelFilter(destination) {
      this.$nextTick(() => {
        document
          .querySelector(destination)
          .scrollIntoView({ behavior: "smooth", block: "center" });
      });
    },

    clearSecondLevelFilters: function () {
      Object.keys(this._getStore().secondLevelFilters).forEach((group) => {
        this._getStore().secondLevelFilters[group] = [];

        if (this.secondLevelFiltersConfig[group].showSelectAllToggle) {
          this._getStore().secondLevelFilters[group].push("");
        }
      });

      // uncheck all filters except 'All'
      this.$root
        .querySelectorAll('.ds-filter-megamenu__filters input[type="checkbox"]')
        .forEach((checkbox) => (checkbox.checked = !checkbox.value));

      this._delayedApplyFilters();
    },

    lookupFilterLabel(config, value) {
      let label = value;
      for (let i = 0; i < config.options.length; i++) {
        const _option = config.options[i];
        if (_option.value === value) {
          label = _option.label;
          break;
        }
      }

      return label;
    },

    _updateFilterOptionsUIState() {
      // show/hide other options
      const elemSelectedStudyLevel = document.querySelector(
        'input[name="studyLevels"]:checked'
      );

      if (elemSelectedStudyLevel) {
        const studyLevel = elemSelectedStudyLevel.value;

        document
          .querySelectorAll('input[name="studyFlexOptions"]')
          .forEach((_elem) => {
            const _showElem = {
              UG: ["course", "major", "minor"],
              PG: ["course", "specialisation"],
            }[studyLevel].includes(_elem.value);

            if (_showElem) {
              _elem.parentNode.style.removeProperty("display");
            } else {
              _elem.parentNode.style.display = "none";
            }
          });
      }
    },
  }));
});
